import React from 'react';
import { isNative } from '../capacitor';

// The public support page lives outside the app (no sign-in, no navigation), so it opens in a new
// tab. The native apps load their bundled copy in the app's own WebView instead: the system or
// in-app browser has a separate session, so its Agent Hotline button would ask the agent to sign in
// again. ?app tells the page to show a way back, since it has none of the app's navigation.
const SUPPORT_PATH = '/support.html';

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'>;

const SupportPageLink: React.FC<Props> = ({ onClick, ...props }) => (
  <a
    {...props}
    href={SUPPORT_PATH}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => {
      onClick?.(e);
      if (!isNative) return;
      e.preventDefault();
      window.location.assign(`${SUPPORT_PATH}?app`);
    }}
  />
);

export default SupportPageLink;
